import React from "react";
import SvgIcn from "../../../data/IconCompo";
import TagZ from "../../atoms/TagZ";
import PropTypes from "prop-types";

const TagSelector = ({ availableTags, selectedTags, onToggle }) => {
  return (
    <>
      <div className="form-group">
        {/* <label className="form-label">Filter Tags</label> */}
        <div className="tags-container">
          {availableTags.map((tag) => (
            <label
              key={tag}
              className={`tag-checkbox ${
                selectedTags.includes(tag) ? "selected" : ""
              }`}
            >
              <input
                type="checkbox"
                checked={selectedTags.includes(tag)}
                onChange={() => onToggle(tag)}
                style={{ display: "none" }}
              />
              <div className="checkbox">
                {selectedTags.includes(tag) && <SvgIcn name="check" />}
              </div>
              <span>{tag}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Selected Tags Display */}
    </>
  );
};

TagSelector.propTypes = {
  availableTags: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedTags: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default TagSelector;
